import { linko } from "@shared/linko";
import type {
  AddManualMatchBody,
  AssignManualMatchDateBody,
  ManagerDailyMatchesQueryBody,
  ManagerDailyMatchesResult,
  MatchBankEntry,
} from "./types";

type StatisticsQueriesManagerMatches = {
  getManagerDailyMatches: (
    body: ManagerDailyMatchesQueryBody,
  ) => Promise<{ data: ManagerDailyMatchesResult }>;
  listMatchBank: (body: {
    organizationId: string;
  }) => Promise<{ data: MatchBankEntry[] }>;
};

type StatisticsMutationsManualMatch = {
  addManualMatch: (
    body: AddManualMatchBody,
  ) => Promise<{ data: { id: string } }>;
  assignManualMatchDate: (
    body: AssignManualMatchDateBody,
  ) => Promise<{ data: { id: string } }>;
};

export async function fetchManagerDailyMatches(
  body: ManagerDailyMatchesQueryBody,
): Promise<ManagerDailyMatchesResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesManagerMatches;
  const { data } = await queries.getManagerDailyMatches(body);
  return data;
}

export async function fetchMatchBank(
  organizationId: string,
): Promise<MatchBankEntry[]> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesManagerMatches;
  const { data } = await queries.listMatchBank({ organizationId });
  return data.map((row) => ({
    ...row,
    createdAt:
      typeof row.createdAt === "string"
        ? row.createdAt
        : new Date(row.createdAt as unknown as Date).toISOString(),
  }));
}

export async function addManualMatch(
  body: AddManualMatchBody,
): Promise<{ id: string }> {
  const mutations = linko.statistics
    .mutations as unknown as StatisticsMutationsManualMatch;
  const { data } = await mutations.addManualMatch(body);
  return data;
}

export async function assignManualMatchDate(
  body: AssignManualMatchDateBody,
): Promise<{ id: string }> {
  const mutations = linko.statistics
    .mutations as unknown as StatisticsMutationsManualMatch;
  const { data } = await mutations.assignManualMatchDate(body);
  return data;
}
